import { render } from "./SectionTree.vue?vue&type=template&id=fefe066c&scoped=true"
import script from "./SectionTree.vue?vue&type=script&lang=js"
export * from "./SectionTree.vue?vue&type=script&lang=js"

import "./SectionTree.vue?vue&type=style&index=0&id=fefe066c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fefe066c"]])

export default __exports__